import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GetUserQueryService {

  constructor(private http:HttpClient) { }
  getUserQuery() {
    var url = `${environment.apiConfig.uri}/candidate/Superannuation/GetUserQuery`;
   return this.http.get(url);
  }
}
